<template>
  <div class="nav">
    <div style="position: relative;">
      <div class="nav-content" ref="nav">
        <div class="nav-logo" v-if="!state">
          <div style="height:100%;width:100%" v-show="logoShow">
            <img
              v-if="logoContent"
              src="../../static/img1/logo.webp"
              class="logo"
            />
            <img v-else class="logo" :src="this.imgLogo" />
          </div>
        </div>
        <div class="nav-lists" ref="list">
          <ul>
            <li
              class="nav-item"
              :class="{ navactive: index == ind }"
              @mouseover="cover(item)"
              @mouseleave="leave()"
              v-for="(item, index) in navList"
              :key="index"
            >
              <div
                class="nav-text"
                @click="firstClick(item)"
                v-if="item.isShow && index < 6"
              >
                {{ item.title }}
              </div>
            </li>
          </ul>

          <div
            class="nav-item"
            @mouseover="decide()"
            @mouseleave="clear()"
            v-show="decide()"
            :class="{ navactive: ind >= 6 }"
          >
            <div class="text"></div>
            <div v-show="isShow" class="nav-down-wraps">
              <div
                v-show="item.isShow && index > 5"
                v-for="(item, index) in navList"
                :key="index"
                v-on:click="firstClick(item)"
                class="down-item"
              >
                {{ item.title }}
                <div class="dian"></div>
              </div>
            </div>
          </div>
        </div>

        <div
          class="nav-down-wrap"
          @mouseenter="enter()"
          @mouseleave="leave()"
          v-show="isNav"
          :style="{ width: windowWidth }"
        >
          <div class="nav-img"></div>
          <div class="nav-down-wrap1">
            <div class="nav-down-iton">{{ this.title }}</div>
            <div class="nav-down-iton1">{{ this.introduce }}</div>
          </div>
          <div class="nav-down-iton2">
            <div
              class="nav-icon"
              v-for="(item, index1) in list"
              :key="index1"
              @click="secondClick(item)"
            >
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      navList: [],
      windowWidth: "100%",
      isNav: false,
      list: [],
      ind: 0,
      title: "",
      state: true,
      introduce: "",
      isShow: false,
      logoContent: true,
      imgLogo: "",
      logoShow: false
    };
  },
  watch: {
    $route: {
      handler: function(to, from) {
        this.getNav();
        this.getLogo();
        let query1 = this.$route.query;
        if (this.$route.path === "/Portal") this.ind = 0;
        else if (query1.id && this.$route.path === "/Portal/solution") {
          let item = this.navList.find(item => item.id === query1.id);
          this.ind = item.ordina - 1;
        } else {
          let arr = [];
          for (let i = 0; i < this.navList.length; i++) {
            if (this.navList[i].param) arr.push(this.navList[i]);
            if (this.navList[i].childList) {
              for (let j = 0; j < this.navList[i].childList.length; j++) {
                if (this.navList[i].childList[j].param)
                  arr.push(this.navList[i].childList[j]);
              }
            }
          }
          let q = arr.find(
            item =>
              "/Portal" + JSON.parse(item.param).route === this.$route.path
          );
          if (q.parent) {
            this.ind = Math.trunc(q.ordina / 100) - 1;
          } else {
            this.ind = q.ordina - 1;
          }
        }
      },
      deep: true
    }
  },
  async mounted() {
    await this.getNav();
    await this.getLogo();
    let query1 = this.$route.query;
    //如果为主页的话
    if (this.$route.path === "/Portal") this.ind = 0;
    //如果为预设的solution组件的话我们更新
    else if (query1.id && this.$route.path === "/Portal/solution") {
      let item = this.navList.find(item => item.id === query1.id);
      this.ind = item.ordina - 1;
    }
    //此为不关联cms的情况，我们遍历对应两层数组得到ordina，最后进行更新
    else {
      let arr = [];
      for (let i = 0; i < this.navList.length; i++) {
        if (this.navList[i].param) arr.push(this.navList[i]);
        if (this.navList[i].childList) {
          for (let j = 0; j < this.navList[i].childList.length; j++) {
            if (this.navList[i].childList[j].param)
              arr.push(this.navList[i].childList[j]);
          }
        }
      }
      let q = arr.find(
        item => "/Portal" + JSON.parse(item.param).route === this.$route.path
      );
      if (q.parent) {
        this.ind = Math.trunc(q.ordina / 100) - 1;
      } else {
        this.ind = q.ordina - 1;
      }
    }
    window.onresize = () => {
      return (() => {
        this.windowWidth = document.body.clientWidth + "px";
        // this.screenWidth();
      })();
    };
  },

  methods: {
    firstClick(item) {
      //如果未关联CMS的话，我们根据对应的param进行跳转
      if (!item.isCMS) {
        let param1 = JSON.parse(item.param);
        if (!param1.query) this.$router.push("/Portal" + param1.route);
        else {
          this.$router.push({
            path: "/Portal" + param1.route,
            query: param1.query
          });
        }
      }
      //关联CMS的情况下，我们按照默认模板进行渲染
      else {
        if (item.ordina === 1) this.$router.push("/Portal");
        else {
          if (item.childList.length === 0) {
            this.$router.push({
              path: "/Portal/solution",
              query: {
                id: item.id
              }
            });
          } else {
            this.$router.push({
              path: "/Portal/solution",
              query: {
                id: item.id,
                tagnum: item.childList[0].ordina
              }
            });
          }
        }
      }
    },
    // 用户点击二级导航
    secondClick(item) {
      if (!item.isCMS) {
        let param1 = JSON.parse(item.param);
        if (!param1.query) this.$router.push("/Portal" + param1.route);
        else {
          this.$router.push({
            path: "/Portal" + param1.route,
            query: param1.query
          });
        }
      } else {
        let item1 = this.navList.find(qwe => qwe.id === item.parent);
        let ID = item1.id;
        this.$router.push({
          path: "/Portal/solution",
          query: {
            id: ID,
            tagnum: item.ordina
          }
        });
      }
    },
    sortby(prop, rev = true) {
      return function(a, b) {
        var val1 = a[prop];
        var val2 = b[prop];
        return rev ? val1 - val2 : val2 - val1;
      };
    },
    //获取并处理对应数据并发出一个请求，在主页面中的各个组件接收作为参数。
    async getNav() {
      await GMS.$http
        .get("/home/getNavigation")
        .then(res => {
          if (res.status == 200) {
            let data = res.data;
            let navList = [];
            for (let i = 0; i < data.length; i++) {
              if (!data[i].parent) {
                data[i].childList = [];
                navList.push(data[i]);
              }
            }
            let childList = data.filter(item => {
              return item.parent;
            });
            for (let i = 0; i < navList.length; i++) {
              for (let j = 0; j < childList.length; j++) {
                if (navList[i].id == childList[j].parent) {
                  navList[i].childList.push(childList[j]);
                }
              }
            }
            navList.sort(this.sortby("ordina"));
            this.navList = navList;
            //存储对应的导航列表，保证首页各模块和详情页等其他组件可以动态获取对应的id值，保证对应的跳转。
            sessionStorage.setItem("navList", JSON.stringify(navList));
            let inform = navList.find(value => {
              if (value.title === "通知公告") {
                return value.cmsId;
              }
            });
            let guide = navList.find(value => {
              if (value.title === "办事指南") {
                return value.cmsId;
              }
            });
            let worker = navList.find(value => {
              if (value.title === "工作动态") {
                return value.cmsId;
              }
            });
            GMS.vbus.$emit("getId", {
              inform: inform ? inform.cmsId : true,
              guide: guide ? guide.cmsId : true,
              workerId: worker ? worker.cmsId : true
            });
          }
        })
        .catch(error => {
          GMS.vbus.$emit("getId", {
            inform: true,
            guide: true,
            workerId: true
          });
          this.$Message.error("获取数据异常，请联系管理员");
        });
    },
    cover(item) {
      if (item.childList.length > 0) {
        this.isNav = true;
        this.list = item.childList;
        this.title = item.title;
        this.introduce = item.description;
      }
    },
    leave() {
      this.isNav = false;
    },
    enter() {
      this.isNav = true;
    },
    decide() {
      if (this.navList.length > 6) {
        for (let i = 6; i < this.navList.length; i++) {
          if (this.navList[i].isShow) {
            this.isShow = true;
            return true;
          }
          this.isShow = false;
          return false;
        }
        this.isShow = false;
        return false;
      }
    },
    clear() {
      this.isShow = false;
    },
    async getLogo() {
      await GMS.$http
        .get("/portal/logo/query")
        .then(res => {
          if (res.status == 200) {
            if (res.data.content) {
              this.imgLogo = res.data.content;
              this.logoContent = false;
            }
            this.logoShow = true;
          }
        })
        .catch(error => {
          this.logoShow = true;
          this.$Message.error("获取数据异常，请联系管理员");
        });
    }
  }
};
</script>

<style lang="less" scoped>
.nav {
  width: 100%;
  height: 60px;
  background: #015293;
  margin-bottom: 80px;
}

.nav-content {
  width: 1200px;
  // position: relative;
}

@media screen and (max-width: 1500px) {
  .nav-content {
    width: 1200px;
  }
  .nav-text {
    margin-left: 16px !important;
    margin-right: 16px !important;
  }
  .nav-icon {
    margin-right: 30px !important;
  }
  .nav-down-wrap1 {
    width: 1000px !important;
  }
  .nav-down-iton2 {
    width: 1000px !important;
  }
}

@media screen and (min-width: 1500px) and (max-width: 1800px) {
  .nav-content {
    width: 1400px;
  }
  .nav-text {
    margin-left: 36px !important;
    margin-right: 36px !important;
  }
}

@media screen and (min-width: 1800px) {
  .nav-content {
    width: 1600px;
  }
  .nav-text {
    margin-left: 36px !important;
    margin-right: 36px !important;
  }
}

.nav-content {
  margin: 0 auto;
  .nav-item:hover .nav-down-wrap {
    opacity: 1;
  }
  .nav-item:hover .nav-down-wraps {
    opacity: 1;
  }
  .nav-item {
    cursor: pointer;
    float: left;
    height: 60px;
    // margin-right: 60px;
    display: block;
    position: relative;

    .nav-text {
      margin-left: 34px;
      margin-right: 34px;
      font-weight: 500;
      font-size: 20px;
      color: #ffffff;
      letter-spacing: 0;
      line-height: 60px;
      // opacity: 0.89;
      // font-family: PingFangSC-Medium;
    }
  }

  .nav-item:hover {
    background: #0081e9;
  }

  .navactive {
    background: #0081e9;
  }
  .text {
    width: 30px;
    height: 30px;
    margin-top: 15px;
    margin-left: 16px;
    margin-right: 16px;
    background: url("../../static/img1/折叠.webp") no-repeat;
  }

  .nav-down-wrap {
    height: 143px;
    background: #ffffff;
    position: absolute;
    top: 60px;
    left: 0;
    opacity: 1;
    z-index: 5;
    overflow: hidden;
    box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 0.1);
  }
  .nav-down-wraps {
    width: 150px;
    background: #ffffff;
    position: absolute;
    top: 60px;
    left: -25px;
    opacity: 0;
    z-index: 4;
    overflow: hidden;
    box-shadow: 2px 2px 10px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
  }
  .nav-icon {
    float: left;
    margin-right: 100px;
    margin-top: 16px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #0f0f0f;
    cursor: pointer;
  }
  .nav-icon:hover {
    color: #0081e9;
  }
  li {
    list-style-type: none;
  }
  .nav-down-wrap1 {
    height: 52px;
    border-bottom: 1px solid #e3e3e3;
    width: 1162px;
    margin-left: 160px;
    overflow: hidden;
  }
  .nav-down-iton {
    float: left;
    font-size: 16px;
    font-weight: 500;
    line-height: 52px;
    color: #0081e9;
    font-family: PingFangSC-Medium;
  }
  .nav-down-iton1 {
    float: left;
    margin-left: 20px;
    font-size: 12px;
    font-weight: 300;
    color: #0f0f0f;
    font-family: PingFangSC;
    line-height: 52px;
  }
  .nav-down-iton2 {
    overflow: hidden;
    width: 1190px;
    margin-left: 160px;
  }
  .nav-img {
    float: left;
    width: 150px;
    height: 114px;
    opacity: 5;
    margin-left: 1px;
    margin-top: 28px;
    background: url(../../static/img1/底图.webp) no-repeat;
    background-size: 150px 84px;
    background-color: #ffffff;
  }
  .nav-logo {
    float: left;
    width: 297px;
    height: 41px;
    margin-top: 10px;
    margin-right: 130px;
    // background: url('../../static/img1/logo.webp') no-repeat;
  }
  .logo {
    object-fit: cover;
    width: 100%;
    height: 100%;
  }
  .nav-iton {
    float: left;
    font-weight: 500;
    font-size: 25px;
    margin-left: 15px;
    color: #ffffff;
    line-height: 60px;
  }

  .down-item {
    cursor: pointer;
    height: 20px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    font-size: 14px;
    color: #0f0f0f;
    line-height: 20px;
    text-indent: 20px;
    margin-top: 10px;
    margin-bottom: 10px;
    position: relative;
  }
  .dian {
    position: absolute;
    width: 5px;
    height: 5px;
    border-radius: 5px;
    background: #23a9ff;
    top: 8px;
    left: 8px;
    opacity: 0;
  }
  .down-item:hover .dian {
    opacity: 1;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/navS.vue